export default __webpack_public_path__ + "static/media/night-castle-crow.b485543a.jpg";